module.exports = __webpack_public_path__ + "img/student5.afeca09a.png";